import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M92 22h16v20H92z\"></path><circle cx=\"100\" cy=\"20\" r=\"8\"></circle><path d=\"M38 46h124v120H38z\"></path><path fill=\"var(--mc-avatar)\" d=\"M62 76h32v22H62zM106 76h32v22h-32z\"></path><path d=\"M74 83h8v8h-8zM118 83h8v8h-8z\"></path><path fill=\"var(--mc-avatar)\" d=\"M68 124h64v10H68z\"></path><path stroke=\"currentColor\" stroke-width=\"3\" d=\"M78 124v10M94 124v10M110 124v10\"></path><path d=\"M20 80h14v40H20zM166 80h14v40h-14z\"></path>", 8)
  ]))]))
}
export default { render: render }